import axios from "./axios.config";

const baseUrl =  process.env.VUE_APP_ADMIN_SERVER_URL

function serializeParams(params) {
    return Object.keys(params || {})
        .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')
}

function serializeNodeAccessParams(params) {
    const parts = []
    Object.keys(params || {}).forEach(key => {
        const value = params[key]
        if (value === undefined || value === null || value === '') return
        if (key === 'filter' && Array.isArray(value)) {
            value.forEach((filter, index) => {
                Object.keys(filter).forEach(filterKey => {
                    parts.push(`${encodeURIComponent(`filter[${index}][${filterKey}]`)}=${encodeURIComponent(filter[filterKey])}`)
                })
            })
            return
        }
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    })
    return parts.join('&')
}

const instance = {
    getUserList(params) {
        return axios.get(`${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/fetch`, {
            params: params,
            paramsSerializer: serializeParams,
        })
    },
    getNodeAccessOptions() {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/node-access/options`)
    },
    getNodeAccessUsers(params) {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/fetch`, {
            params,
            paramsSerializer: serializeNodeAccessParams,
        })
    },
    updateNodeAccess(params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/node-access/update`, params)
    },
    getNodeAccessLogs(params) {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/node-access/log/fetch`, {
            params,
            paramsSerializer: serializeParams,
        })
    },
    signIn(params, callback) {
        axios.post(`${baseUrl}/api/v1/passport/auth/login`, params)
            .then(data => callback(data))
    },
    getSubscribeList() {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/plan/fetch`)
    },
    getGroups() {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/group/fetch`)
    },
    saveGroup(params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/group/save`, params)
    },
    deleteGroup(params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/group/drop`, params)
    },
    getRoutes() {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/route/fetch`)
    },
    saveRoute(params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/route/save`, params)
    },
    deleteRoute(params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/route/drop`, params)
    },
    getManagedNodes() {
        return axios.get(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/manage/getNodes`)
    },
    sortManagedNodes(params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/manage/sort`, params)
    },
    saveNode(type, params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/${type}/save`, params)
    },
    updateNode(type, params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/${type}/update`, params)
    },
    copyNode(type, params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/${type}/copy`, params)
    },
    deleteNode(type, params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/server/${type}/drop`, params)
    },
    addSubscribe (params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/plan/save`,params)
    },
    updateSubscribe (params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/plan/update`,params)
    },
    deleteSubscribe (params) {
        return axios.post(`${baseUrl}/api/v1/${process.env.VUE_APP_ADMIN_SECURE_PATH}/plan/drop`,params)
    },
    getBillEntryList(params,callback) {
       axios.get(`${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/order/commission/list`,{params}).then(data => callback(data))
    },
    getWithdrawInfo(params) {
        return axios.get(`${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/commission/withdraw/info`, {params: params})
    },
    getWithdrawLogList(params,callback) {
        axios.get(`${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/commission/withdraw/log/list`, {params}).then(data => callback(data))
    },
    /**
     * 提现
     * @param params（transfer_amount）
     * @param callback
     */
    postWithdraw(params, callback){
        axios.post(`${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/commission/withdraw`, params)
            .then(data => callback(data))
    },
    /**
     * 订单统计：按套餐 + 订单类型 + 时间维度
     */
    getOrderStats(params) {
        return axios.get(`${baseUrl}/api/v2/internal/statistic/orderStats`, { params })
    },
    /**
     * 管理端统计记录：按类型查询每日记录
     */
    getAdminStatRecords(params) {
        return axios.get(
            `${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/stat/record`,
            {params},
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    /**
     * 用户每日汇总：按日期 + 权限组 + 套餐统计活跃/存活用户
     */
    getUserDailySummary(params) {
        return axios.get(`${baseUrl}/api/v2/internal/statistic/userDailySummary`, { params })
    },
    /**
     * DA 自研客户端每日统计：查询跨平台及各平台去重用户趋势
     */
    getDAClientDailyUsers(params) {
        return axios.get(`${baseUrl}/api/v2/internal/statistic/daClientDailyUsers`, { params })
    },
    /**
     * 订单用户明细：按套餐 + 日期范围查询
     */
    getOrderUsers(params) {
        return axios.get(`${baseUrl}/api/v2/internal/statistic/orderUsers`, { params })
    },
    getConversionDashboard(params) {
        return axios.get(`${baseUrl}/api/v2/internal/statistic/conversions`,
            {params})
    },

    getConversionUsers(params) {
        return axios.get(`${baseUrl}/api/v2/internal/statistic/users`,
            {params})
    },
    /**
     * 用量统计：查询用户流量记录（日/月）
     */
    getUserUsageRecords(params) {
        return axios.get(`${baseUrl}/api/v2/${process.env.VUE_APP_ADMIN_SECURE_PATH}/user/traffic/log`, {params})
    },
    /**
     * 用户评分：查询连续高分用户
     */
    getContinuousHighScoreUsers(params) {
        return axios.get(`/grayuser/api/v1/risk-users/continuous-high-score`, {
            params,
            paramsSerializer: serializeParams,
        })
    }
}
export default instance
